import { Auth0ContextInterface } from '@auth0/auth0-react';
import { redirectToLogout, redirectToV2Logout } from '../utils/tokenUtils';
import Axios, { AxiosError, AxiosInstance } from 'axios';
import Config from 'Config';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';

interface Auth0Context {
  getAccessTokenSilently?: Auth0ContextInterface['getAccessTokenSilently'];
  isAuthenticated?: boolean;
  logout?: Auth0ContextInterface['logout'];
}

const auth0Context: Auth0Context = {
  getAccessTokenSilently: undefined,
  isAuthenticated: false,
  logout: undefined,
};

export const addAuth0Context = (
  getAccessTokenSilently: Auth0ContextInterface['getAccessTokenSilently'],
  isAuthenticated: boolean,
  logout: Auth0ContextInterface['logout'],
) => {
  auth0Context.getAccessTokenSilently = getAccessTokenSilently;
  auth0Context.isAuthenticated = isAuthenticated;
  auth0Context.logout = logout;
};

export function addInterceptors(axios: AxiosInstance, ignoreRedirect?: boolean) {
  axios.interceptors.request.use(
    async (config) => {
      const token = LocalAuth.getTokenValue();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        return config;
      }
      if (auth0Context.getAccessTokenSilently) {
        const token = await auth0Context.getAccessTokenSilently();
        config.headers.Authorization = `Bearer ${token}`;
        return config;
      }
    },
    (error: AxiosError): Promise<AxiosError> => Promise.reject(error),
  );
  if (!ignoreRedirect) {
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          LocalAuth.clearStorage();
          if (auth0Context.isAuthenticated) {
            redirectToV2Logout();
          } else {
            redirectToLogout(Config.rtsProUrl);
          }
        }
        return Promise.reject(error);
      },
    );
  }
}

export default class Service {
  axios: AxiosInstance;

  constructor(serviceUrl: string) {
    this.axios = Axios.create({
      baseURL: serviceUrl,
    });
    addInterceptors(this.axios);
  }
}
